module.exports = __webpack_public_path__ + "media/images/80stees_logo-8c2e240d7716f91cdd9dfbcaaa9f9299.png";